export const ibanNumberRegexp = /^[A-Z]{2}\d{2} \d{4} \d{4} \d{4} \d{4} \d{4}$/

export const isValidIBANNumber = iban => {
  return ibanNumberRegexp.test(iban)
}
